export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/50401684-28bf-469b-9849-5afe701309e8/images/33c13737d3d6d0a074f2b723b7fd4f0fdc273de026efbd01dc451931d2a9a391.jpeg",
  jointExercise: "https://static.prod-images.emergentagent.com/jobs/50401684-28bf-469b-9849-5afe701309e8/images/b7d201520ed157733a2cc6aa67c2b91772fcdad8a954aee560921eba4f5f484c.jpeg",
  simulation: "https://static.prod-images.emergentagent.com/jobs/50401684-28bf-469b-9849-5afe701309e8/images/a04c68a74291beabfcbfb270a326cbb5611264448f1332a1dfa1f918905def0f.jpeg",
  commandCenter: "https://static.prod-images.emergentagent.com/jobs/50401684-28bf-469b-9849-5afe701309e8/images/10d9152e237e4dcf547f8968fa3509a03a09293aec13e58612c712e82c69bf38.jpeg",
  hospitalHandoff: "https://static.prod-images.emergentagent.com/jobs/50401684-28bf-469b-9849-5afe701309e8/images/b5a45f07cc1dad711a7848cb5f80e8cb458fa79290da359dc1278e6d69bac6f2.jpeg",
  gearDetail: "https://static.prod-images.emergentagent.com/jobs/50401684-28bf-469b-9849-5afe701309e8/images/45ae4b32b2ace63fd9bc4baa5eeb70ac7bc45187d74a8c95eda7e6b1da941913.jpeg",
  architect: "/images/gabriel-boris-galvani.jpg",
};

export const NAV_LINKS = [
  { to: "/about", label: "About" },
  { to: "/framework", label: "Framework" },
  { to: "/pilot", label: "Pilot Model" },
  { to: "/partnerships", label: "Partnerships" },
  { to: "/research", label: "Research" },
];

export const ALL_LINKS = [
  { to: "/", label: "Home", num: "01" },
  { to: "/about", label: "About", num: "02" },
  { to: "/framework", label: "Framework", num: "03" },
  { to: "/pilot", label: "Pilot Model", num: "04" },
  { to: "/partnerships", label: "Partnerships", num: "05" },
  { to: "/research", label: "Research", num: "06" },
  { to: "/governance", label: "Governance", num: "07" },
  { to: "/architect", label: "Program Architect", num: "08" },
  { to: "/resources", label: "Resources", num: "09" },
  { to: "/faq", label: "FAQ", num: "10" },
  { to: "/contact", label: "Contact", num: "11" },
];

export const CREDIBILITY = [
  "TECC / TCCC",
  "NIMS / ICS",
  "National EMS Education Standards",
  "NEMSIS",
  "NEMSQA",
  "Local Medical Direction",
  "Agency Protocols",
];
